export default __webpack_public_path__ + "static/media/icon-call-answer.c2747fd6.svg";